import { render } from "./App.vue?vue&type=template&id=2a5d0515"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2a5d0515&lang=scss"

import exportComponent from "C:\\Users\\ThinleyNorbu\\source\\repos\\1185_BF_Module_0\\vueOktaVersion\\custom-login\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__